module.exports = __webpack_public_path__ + "img/portadapredial.cfd1dd04.jpg";